"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.underlineNone = exports.smallText = exports.setWordBreak = exports.setDisabled = exports.setAlign = exports.noPadding = exports.dangerStyles = exports.NoStyle = exports.LinkStyle = exports.IconLinkWrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const IconLinkWrapper = exports.IconLinkWrapper = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "e1besegt0"
} : {
  target: "e1besegt0",
  label: "IconLinkWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : {
  name: "s5xdrg",
  styles: "display:flex;align-items:center",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const NoStyle = exports.NoStyle = process.env.NODE_ENV === "production" ? {
  name: "1wl9p5d",
  styles: "color:inherit;font-size:inherit;font-weight:inherit;text-decoration:none;line-height:inherit;background-color:transparent;border:none"
} : {
  name: "1hvmcz2-NoStyle",
  styles: "color:inherit;font-size:inherit;font-weight:inherit;text-decoration:none;line-height:inherit;background-color:transparent;border:none;label:NoStyle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1av5gp9",
  styles: "background:none;border:none;outline:none;color:#1657e2;font-size:16px;font-weight:600;letter-spacing:0;line-height:20px;text-decoration:underline;cursor:pointer;&:hover,&:focus,&:active{text-decoration:none;}&:focus-visible{outline:1px dotted #212121;outline:5px auto -webkit-focus-ring-color;}"
} : {
  name: "15cykwf-LinkStyle",
  styles: "background:none;border:none;outline:none;color:#1657e2;font-size:16px;font-weight:600;letter-spacing:0;line-height:20px;text-decoration:underline;cursor:pointer;&:hover,&:focus,&:active{text-decoration:none;}&:focus-visible{outline:1px dotted #212121;outline:5px auto -webkit-focus-ring-color;};label:LinkStyle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const LinkStyle = () => _ref;
exports.LinkStyle = LinkStyle;
const dangerStyles = theme => /*#__PURE__*/(0, _react.css)("color:", theme.btnDanger, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:dangerStyles;"));
exports.dangerStyles = dangerStyles;
const noPadding = exports.noPadding = process.env.NODE_ENV === "production" ? {
  name: "1hcx8jb",
  styles: "padding:0"
} : {
  name: "c79p2l-noPadding",
  styles: "padding:0;label:noPadding;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const setAlign = align => /*#__PURE__*/(0, _react.css)("text-align:", align, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:setAlign;"));
exports.setAlign = setAlign;
const smallText = exports.smallText = process.env.NODE_ENV === "production" ? {
  name: "mmdt3g",
  styles: "font-size:14px"
} : {
  name: "1psfcol-smallText",
  styles: "font-size:14px;label:smallText;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const underlineNone = exports.underlineNone = process.env.NODE_ENV === "production" ? {
  name: "lq5caq",
  styles: "text-decoration:none;&:hover,&:focus{text-decoration:underline;}"
} : {
  name: "1fav51k-underlineNone",
  styles: "text-decoration:none;&:hover,&:focus{text-decoration:underline;};label:underlineNone;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const setWordBreak = value => /*#__PURE__*/(0, _react.css)("word-break:", value, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:setWordBreak;"));
exports.setWordBreak = setWordBreak;
const setDisabled = theme => /*#__PURE__*/(0, _react.css)("color:", theme.btnDisabled, ";text-decoration:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:setDisabled;"));
exports.setDisabled = setDisabled;